import { Dayjs, PluginFunc } from 'dayjs';
import { RelativeTimeInput, RelativeTimeOptions, RelativeTimeType, TimeDiffType } from '../type';
import { getPluralType } from '../util';

const plugin: PluginFunc<RelativeTimeOptions> = function (options, dayjsClass, dayjs) {
  const proto = dayjsClass.prototype;
  const fromToBase = function (
    input: RelativeTimeInput,
    instance: Dayjs,
    relativeTimeType: RelativeTimeType | TimeDiffType,
  ): string {
    const localeConfig = instance.$locale();
    const { thresholds, rounding } = options;
    let durationStr = '';

    for (let i = 0; i < thresholds.length; i += 1) {
      const { relativeTimeKey, num, unit } = thresholds[i];
      const thresholdDiff = dayjs(input).diff(instance, unit, true);
      const absThresholdDiff = rounding(Math.abs(thresholdDiff));
      if (absThresholdDiff >= num) {
        const absDiff = rounding(Math.abs(dayjs(input).diff(instance, relativeTimeKey, true)));
        const pluralType: string = getPluralType(absDiff, instance.$locale().name);
        let tense;
        if (relativeTimeType === 'abbr') {
          tense = 'abbr';
        } else if (relativeTimeType === 'full') {
          tense = 'full';
        } else if (thresholdDiff > 0) {
          tense = relativeTimeType === 'normal' ? 'future' : 'futureLong';
        } else {
          tense = relativeTimeType === 'normal' ? 'past' : 'pastLong';
        }
        const templateMap = localeConfig[tense][relativeTimeKey];
        const template = templateMap[pluralType] || '';
        durationStr = template.replace('%s', `${absDiff}`);
        break;
      }
    }
    return durationStr;
  };

  proto.customTo = function (
    input: RelativeTimeInput,
    relativeTimeType: RelativeTimeType | TimeDiffType = 'normal',
  ): string {
    return fromToBase(input, this, relativeTimeType);
  };
};
export default plugin;
